/* eslint react-hooks/rules-of-hooks: "warn" */
import { useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { ContextMenuPluginDependency } from '../../../dependency';
import { IExportContextMenuItem, IRenderContextMenuItemArgs } from '../../../type';
import MenuItem from '../../../views/menu-item';

const render = ({ activeLayer, pickLayer }: IRenderContextMenuItemArgs) => {
    const { $t } = getLocaleStore();
    const framework = useFramework();
    const layer = pickLayer || activeLayer;
    const disabled = !layer;

    if (disabled) return null;
    const disableFlip = framework.getBehavior(layer)?.checkDisableFlip?.(layer);

    const item = {
        disabled,
        name: $t((v) => v.comToolBar.flipBtn.layerRotate),
        type: 'flip',
        childMenus: [
            {
                name: $t((v) => v.comToolBar.flipBtn.horizontalRotate),
                disabled: disableFlip,
                type: 'flipH',
                icon: 'FlipHorizontalBold',
                onClick: () => {
                    framework.getInstance(ContextMenuPluginDependency).flipX(layer.id);
                },
            },
            {
                name: $t((v) => v.comToolBar.flipBtn.verticalRotate),
                disabled: disableFlip,
                type: 'flipV',
                icon: 'FlipVerticalBold',
                onClick: () => {
                    framework.getInstance(ContextMenuPluginDependency).flipY(layer.id);
                },
            },
        ],
    };

    return <MenuItem {...item}></MenuItem>;
};

export default {
    group: 3,
    sort: 2,
    render,
} as IExportContextMenuItem;
